import { RSAA } from 'redux-api-middleware';

// Constants
export const COMPANY_SET_EDIT_MODE = 'COMPANY_SET_EDIT_MODE';
export const COMPANY_IS_FETCHING = 'COMPANY_IS_FETCHING';
export const COMPANY_GET_INFO_SUCCESS = 'COMPANY_GET_INFO_SUCCESS';
export const COMPANY_GET_INFO_ERROR = 'COMPANY_GET_INFO_ERROR';
export const COMPANY_EDIT_SUCCESS = 'COMPANY_EDIT_SUCCESS';
export const COMPANY_EDIT_ERROR = 'COMPANY_EDIT_ERROR';
export const COMPANY_GET_LIST_SUCCESS = 'COMPANY_GET_LIST_SUCCESS';
export const COMPANY_API_ERROR = 'COMPANY_API_ERROR';

// Actions
export const getCompaniesList = queryString => {
  if (!!queryString.orderBy && queryString.orderBy.startsWith(':')) {
    delete queryString.orderBy;
  }
  return {
    [RSAA]: {
      controlKey: 'CTRL_EMPLOYER',
      controlAction: 'collection',
      queryString,
      types: [
        COMPANY_IS_FETCHING,
        {
          type: COMPANY_GET_LIST_SUCCESS,
          meta: { ...queryString }
        },
        COMPANY_API_ERROR
      ]
    }
  };
};

export const setCompanyInEditMode = isEditMode => {
  return {
    type: COMPANY_SET_EDIT_MODE,
    isEditMode
  };
};

export const getCompanyInfo = () => {
  return {
    [RSAA]: {
      controlKey: 'CTRL_CURRENT_EMPLOYER',
      controlAction: 'self',
      types: [COMPANY_IS_FETCHING, COMPANY_GET_INFO_SUCCESS, COMPANY_GET_INFO_ERROR]
    }
  };
};

export const editCompanyInfo = data => {
  return {
    [RSAA]: {
      controlKey: 'CTRL_CURRENT_EMPLOYER',
      controlAction: 'edit',
      body: data,
      types: [COMPANY_IS_FETCHING, COMPANY_EDIT_SUCCESS, COMPANY_EDIT_ERROR]
    }
  };
};

// Initial State
export const initialState = {
  isEditMode: false,
  isFetching: false,
  data: null,
  error: null,
  filters: [
    {
      key: 'tokenFilter',
      label: 'Token',
      isRadio: true,
      values: [
        { value: 'true', label: 'Yes' },
        { value: 'false', label: 'No' }
      ],
      selectedValue: null
    }
  ],
  searchQuery: null,
  defaultSearchParams: {
    perPage: 10,
    page: 1,
    orderBy: 'businessName:asc'
  },
  sorting: {
    prop: 'businessName',
    direction: ':asc'
  },
  pagination: {
    page: 1,
    total: 0
  },
  items: [],
  selectedItem: null
};

// Reducer
export default (state = initialState, action) => {
  switch (action.type) {
    case COMPANY_GET_LIST_SUCCESS:
      let prop, direction;
      if (action.meta.orderBy) {
        let splitted = action.meta.orderBy.split(':');
        prop = splitted[0];
        if (prop === state.sorting.prop) {
          direction = splitted[1];
        } else {
          direction = 'asc';
        }
      } else {
        prop = '';
      }
      direction = direction === 'asc' ? ':desc' : ':asc';
      const out = {
        ...state,
        isFetching: false,
        error: null,
        items: action.payload.items,
        searchQuery: action.meta && action.meta.search ? action.meta.search : null,
        pagination: {
          ...state.pagination,
          page: +action.meta.page,
          total: action.payload.pageCount
        },
        sorting: {
          ...state.sorting,
          prop: prop,
          direction: direction
        }
      };
      return out;
    case COMPANY_SET_EDIT_MODE:
      return {
        ...state,
        isEditMode: action.isEditMode
      };
    case COMPANY_IS_FETCHING:
      return {
        ...state,
        isFetching: true,
        error: null
      };
    case COMPANY_GET_INFO_SUCCESS:
      return {
        ...state,
        isFetching: false,
        error: null,
        data: action.payload
      };
    case COMPANY_GET_INFO_ERROR:
    case COMPANY_EDIT_ERROR:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };
    case COMPANY_EDIT_SUCCESS:
      return {
        ...state,
        isFetching: false,
        isEditMode: false,
        error: null,
        data: action.payload ? action.payload.employer : state.data
      };
    case COMPANY_API_ERROR:
      return {
        ...state,
        isFetching: false,
        error: action.payload
      };
    case '@@router/LOCATION_CHANGE':
      return {
        ...state,
        isEditMode: false
      };
    default:
      return state;
  }
};
